import React from "react";
import PropTypes from "prop-types";
import IconChips from "./IconChips";

const ChipGroup = ({ options, selected, onChange, variant }) => {
  const handleSelect = (item) => {
    onChange(item.value);
  };

  return (
    <div
      className={` grid ${variant === "icon" ? `grid-cols-2` : variant === "small-icon" ? `grid-cols-2` : options.length >= 3 ? `grid-cols-3` : `grid-cols-2`} gap-4`}
    >
      {options.map((option) => (
        <IconChips
          key={option.value}
          item={option}
          isSelected={selected === option.value}
          onSelect={handleSelect}
          variant={variant}
        />
      ))}
    </div>
  );
};

ChipGroup.propTypes = {
  options: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string,
      heading: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      color: PropTypes.string,
      selectedColor: PropTypes.string,
      borderColor: PropTypes.string,
      selectedBorderColor: PropTypes.string,
      backgroundColor: PropTypes.string,
      selectedBackgroundColor: PropTypes.string,
    })
  ).isRequired,
  selected: PropTypes.string.isRequired, // Change from array to string
  onChange: PropTypes.func.isRequired,
  variant: PropTypes.oneOf(["default", "icon", "small-icon"]),
};

export default ChipGroup;
